export default {
  title: 'Profil Użytkownika',
  close: 'Zamknij',
  rules: {
    required: 'Pole jest wymagane',
    min: 'Pole musi mieć przynajmniej',
    max: 'Pole musi mieć maksymalnie',
    characters: 'znaków',
    fieldIncorrect: 'Pole jest niepoprawne',
    loginIncorrect: 'E-mail jest niepoprawny',
    passwordIncorrect: 'Hasło jest niepoprawne',
    passwordMustDiffer: 'Nowe hasło musi się różnić od poprzedniego',
    passwordMustBeSame: 'Hasła nie mogą się różnić',
  },
  user: {
    login: 'Adres e-mail',
    name: 'Nazwa Użytkownika',
    restore: 'Przywróć',
    save: 'Zapisz',
    updated: 'Dane użytkownika zostały zaktualizowane',
  },
  password: {
    old: 'Stare hasło',
    new: 'Nowe hasło',
    repeat: 'Powtórz hasło',
    updated: 'Hasło zostało zaktualizowane',
    updateError: 'Wystąpił błąd. Hasło nie zostało zaktualizowane',
    clear: 'Wyczyść',
    change: 'Zmień hasło',
  },
}
